<!-- TEMPLATE CONTRACT: Ui Modal Component owns the visible Angular template structure for src/app/shared/ui/ui-modal/ui-modal.component.html. -->
<!-- Conditional branch documents the visible UI state for this condition. -->
@if (open()) {
  <div class="ui-modal-overlay" (click)="close()">
    <section
      class="ui-modal"
      [class.ui-modal--allow-overflow]="allowOverflow()"
      [attr.aria-label]="title() | uiLabelTranslate"
      [style.--ui-modal-max-width]="width() || maxWidth()"
      data-dropdown-boundary
      (click)="$event.stopPropagation()"
    >
      <header class="ui-modal__header">
        <div class="ui-modal__heading">
          <h3>{{ title() | uiLabelTranslate }}</h3>
          <!-- Conditional branch documents the visible UI state for this condition. -->
          @if (description()) {
            <p>{{ description() | uiLabelTranslate }}</p>
          }
        </div>

        <!-- Conditional branch documents the visible UI state for this condition. -->
        @if (showClose()) {
          <!-- Drawer/detail section for record inspection. -->
          <ui-button variant="ghost" icon="close" [ariaLabel]="'Close drawer' | uiLabelTranslate" (click)="close()">
            {{ 'Close' | uiLabelTranslate }}
          </ui-button>
        }
      </header>

      <div class="ui-modal__content" [class.ui-modal__content--allow-overflow]="allowOverflow()">
        <ng-content select="[modalBody]" />
        <ng-content />
      </div>

      <footer class="ui-modal__footer">
        <ng-content select="[modalFooter]" />
      </footer>
    </section>
  </div>
}
